import React, { useState } from 'react';
import './RequestQuote.css';

function RequestQuote({ setCurrentSection, quoteProduct }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    description: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="quote-page">
      <div className="quote-card">
        <div className="quote-card-header">
          <p className="eyebrow">Quotation Request</p>
          <h2>Tell us about your preferred textile</h2>
          <p>We will connect you with the vendor and share the best quote for your order.</p>
        </div>

        {quoteProduct && (
          <div className="quote-product-summary">
            <strong>{quoteProduct.name}</strong>
            <span>{quoteProduct.vendor} • {quoteProduct.location}</span>
          </div>
        )}

        {submitted ? (
          <div className="quote-success">
            <h3>Request received</h3>
            <p>Your request for {formData.description || 'your selected textile'} is on the way. Our team will contact you shortly.</p>
            <button className="back-btn" onClick={() => setCurrentSection('wrappers')}>
              Back to Wrappers
            </button>
          </div>
        ) : (
          <form className="quote-form" onSubmit={handleSubmit}>
            <input name="name" placeholder="Your name" required onChange={handleChange} />
            <input name="email" type="email" placeholder="Email address" required onChange={handleChange} />
            <input name="phone" type="tel" placeholder="Phone number" required onChange={handleChange} />
            <textarea
              name="description"
              rows="5"
              placeholder="Describe your preferred fabric, quantity, event, or design details"
              required
              onChange={handleChange}
            />
            <div className="quote-form-actions">
              <button type="submit" className="submit-btn">Submit Request</button>
              <button type="button" className="secondary-btn" onClick={() => setCurrentSection('wrappers')}>
                Cancel
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default RequestQuote;
